export default "__VITE_ASSET__DZUUAhlY__"